module.exports = __webpack_public_path__ + "images/nkbv_smallf36a0519955c29265dfd557fa67d1243.png";